import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import coupon_frame from "../../Assets/Images/icons/coupon_frame.png"
import axiosInstance from "../../Services/axios";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import CouponCard from "../../Components/Coupon_card/coupon_card";
import { applyCoupon, vendorProductCouponList } from "../../Services/api";
import NodeaxiosInstance from "../../Services/nodeaxios";


export default function Coupon_card_list() {
    const navigate = useNavigate();
    const valueParam = useParams();
    const [coupon_list, setCoupon_list] = useState([])
    const location = useLocation();
    const { cart_id, fromPage, viewOnly = false } = location.state || {}
    const [couponId, setCouponId] = useState(null);
    const [pageLoaded, setPageLoaded] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [couponRawdata, setCouponRawdata] = useState([])
    const [showDescription, setShowDescription] = useState(false)
    const [couponLoadingId, setCouponLoadingId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [myCouponList, setMyCouponList] = useState([])
    const [vendorCouponList, setVendorCouponList] = useState([])

    useEffect(() => {
        vendor_coupons_list()
    }, [])
    const vendor_coupons_list = () => {
        try {

            let reqData = {
                vendor_id: valueParam.vendor_id,
                cart_id: cart_id
            };

            // let reqUrl = fromPage == "product" ?   : "/user/vendor_coupons_list"

            vendorProductCouponList(reqData)
                .then((res) => {
                    let data = res.data;

                    setMyCouponList(data?.my_coupon_list)

                    setVendorCouponList(data?.vendor_coupon_list)
                    setCouponRawdata(data?.my_coupon_list, data?.vendor_coupon_list)


                    setPageLoaded(true)
                })
                .catch((err) => {
                    if (err.response.status == 400 || err.response.status == 500) {
                        toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                    }
                });
        } catch (error) {
            toast(" please content pingle are Try again later", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
        }
    };

    const apply_coupon = (item) => {
        try {
            setBtnLoading(true);
            let reqData = {
                cart_id: cart_id,
                vendor_id: valueParam.vendor_id,
                coupons_id: item.coupons_id,
                coupon_code: item.coupon_code
            }

            // let reqUrl = fromPage == "product" ? "/user_products/apply_coupon" : "/user/apply_coupon";

            applyCoupon(reqData)
                .then((res) => {
                    let data = res.data;
                    navigate(-1)
                })
                .catch((err) => {
                    if (err.response.status == 400 || err.response.status == 500) {
                        toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                    }
                });
        }
        catch {

        }
    }
    const remove_coupon = (item) => {
        try {
            setBtnLoading(true);
            let reqData = {
                cart_id: cart_id,
                coupons_id: item.coupons_id,
            }

            let reqUrl = fromPage == "product" ? '/product/remove_coupon' : '/service/remove_coupon';

            NodeaxiosInstance.post(reqUrl, reqData)
                .then((res) => {
                    let data = res.data;
                    setBtnLoading(false);
                    vendor_coupons_list()

                })
                .catch((err) => {
                    if (err.response.status == 400 || err.response.status == 500) {
                        toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                    }
                });
        }
        catch {

        }
    }

    const filteredMyCoupons = myCouponList?.filter((coupon) =>
        coupon.coupons_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredVendorCoupons = vendorCouponList?.filter((coupon) =>
        coupon.coupons_name.toLowerCase().includes(searchTerm.toLowerCase())
    );




    const handleApply = async (item) => {
        setCouponLoadingId(item.coupons_id); // track which coupon is loading
        await apply_coupon(item);
        setCouponLoadingId(null);
    };

    const handleRemove = async (item) => {
        setCouponLoadingId(item.coupons_id);
        await remove_coupon(item);
        setCouponLoadingId(null);
    };



    return (
        <>
            {pageLoaded ?
                <div className=" ">
                    <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  " >
                        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                            <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
                            <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                                Coupons
                            </div>
                        </div>
                    </div>



                    <div className="p-3">
                        {!viewOnly && (<>
                        <h5 className="fs-14 ff-poppins-semiBold">Enter Coupon Code</h5>
                        <div className="d-flex align-items-center justify-contet-between coupon_search p-2 col-12 mb-3">
                            <input
                                type="search"
                                className="coupon_search_box w-100 border border-0 ff-poppins-semiBold secondary-text-1 fs-14"
                                placeholder="Enter Coupon Code"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="primary-text ff-poppins-semiBold fs-12">Apply</span>
                        </div>
                        </>)}
                        {/* Coupon List */}
                        {
                            filteredMyCoupons?.length > 0 || filteredVendorCoupons?.length > 0 ?
                                <div div className="scroller-style-y" style={{ paddingBottom: "40%" }}>
                                    {filteredMyCoupons?.length > 0 &&
                                        <div>
                                            <h6 className="fs-14 ff-poppins-semiBold">My coupons</h6>
                                            {filteredMyCoupons?.length > 0 ? (
                                                filteredMyCoupons.map((item) => (
                                                    <CouponCard
                                                        key={item.coupons_id}
                                                        item={item}
                                                        couponId={couponId}
                                                        showDescription={showDescription}
                                                        couponLoadingId={couponLoadingId}
                                                        handleApply={handleApply}
                                                        handleRemove={handleRemove}
                                                        setCouponId={setCouponId}
                                                        setShowDescription={setShowDescription}
                                                        viewOnly={viewOnly}
                                                    />
                                                ))
                                            ) : (
                                                <p className="fs-12 ff-poppins-regular text-center">No coupons found</p>
                                            )}
                                        </div>

                                    }

                                    {filteredVendorCoupons?.length > 0 &&
                                        <div>
                                            {!viewOnly && <h6 className="fs-14 ff-poppins-semiBold">More coupons</h6>}
                                            {filteredVendorCoupons?.length > 0 ? (
                                                filteredVendorCoupons.map((item) => (
                                                    <CouponCard
                                                        key={item.coupons_id}
                                                        item={item}
                                                        couponId={couponId}
                                                        showDescription={showDescription}
                                                        couponLoadingId={couponLoadingId}
                                                        handleApply={handleApply}
                                                        handleRemove={handleRemove}
                                                        setCouponId={setCouponId}
                                                        setShowDescription={setShowDescription}
                                                        viewOnly={viewOnly}
                                                    />
                                                ))
                                            ) : (
                                                <p className="fs-12 ff-poppins-regular text-center">No coupons found</p>
                                            )}
                                        </div>}
                                </div>
                                :
                                <p className="fs-14 d-flex justify-content-center align-items-center h-100 ff-poppins-semiBold">No coupons available</p>

                        }
                    </div>

                </div >
                :
                <div className=" ReactLoading">
                    <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} />
                </div>
            }
        </>
    )
}

